import { CheckCompatibilityResponse } from "../../app/features/vehicles/domain/mro-smartcar.model";

export const checkCompatibilityResponseMock: CheckCompatibilityResponse = {
    compatible: true,
};
